export default __webpack_public_path__ + "static/media/company.67a5634d.svg";